import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { InstallationItem } from "@/app/domain/entities/installation";

export class InstallationSubtotalCalculationStrategy extends CalculationStrategy {
    calculate(installationItems: InstallationItem[]): PriceResult {
        if (!installationItems) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculateSubtotalPrice(
                installationItems,
                CostDealType,
            ),
            priceB2C: this.calculateSubtotalPrice(
                installationItems,
                B2CDealType,
            ),
            priceB2B: this.calculateSubtotalPrice(
                installationItems,
                B2BDealType,
            ),
        };
    }

    private calculateSubtotalPrice(
        installationItems: InstallationItem[],
        dealType: string,
    ) {

        const oldSubtotalPrice = installationItems.reduce((sum, item) => sum + (item.sum.getSystemPrice(dealType).getValue() || 0), 0);

        // get max value of minPrice for every installationItem
        const maxMinPrice = Math.max(
            ...installationItems.map(item => (item.minPrice || 0)),
        );

        return oldSubtotalPrice > maxMinPrice ? oldSubtotalPrice : maxMinPrice;
    }
}
